import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

const QrScanner = () => {
    const [scannedResult, setScannedResult] = useState(null);

    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const scanner = new Html5QrcodeScanner('reader', {
            fps: 15,
            showTorchButtonIfSupported: true,
            showZoomSliderIfSupported: true,
            rememberLastUsedCamera: true,
            videoConstraints: {
                facingMode: { ideal: "environment" }
            }
        });

        function success(result) {
            setScannedResult(result);
            try {
                scanner.clear();
            } catch (err) {
                console.warn(err);
            }
            window.open(result, '_self');
        }

        const error = (err) => {
            // Frame scan attempts without a barcode are normal and ignored
        };

        scanner.render(success, error);

        return () => {
            document.body.style.overflow = originalOverflow;
            try {
                scanner.clear().catch(e => console.warn("Failed to clear scanner:", e));
            } catch (err) {
                console.warn(err);
            }
        };
    }, []);

    return (
        <div className="qr-scanner-fullscreen-container">
            <div className="card qr-scanner-card">
                <div className="scanner-header mb-1 text-center">
                    <h4 className="headerfont font-bold mb-0" style={{ color: "rgb(42, 102, 151)", fontSize: '1.25rem' }}>
                        <i className="fa fa-qrcode mr-2"></i>QR Code Scanner
                    </h4>
                </div>

                <div id="reader" className="qr-scanner-box"></div>

                {scannedResult && (
                    <div className="mt-1 p-1 border-round surface-100 text-700 text-xs text-center">
                        <i className="fa fa-check-circle text-green-500 mr-1"></i>
                        Scanned: <span className="font-semibold">{scannedResult}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default QrScanner;